import React from 'react';
import './Footer.css';

const Footer = () => {
  const footerLinks = [
    { label: 'Platform', href: '#platform' },
    { label: 'Security', href: '#firewall' },
    { label: 'Documentation', href: '#documentation' },
    { label: 'Company', href: '#company' },
    { label: 'Privacy', href: '#privacy' },
    { label: 'Terms', href: '#terms' },
    { label: 'Contact', href: 'mailto:contact@vantasignal.app' },
  ];

  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <a href="/" className="footer-logo" data-testid="footer-logo">
              <span className="footer-logo-icon">VS</span>
              <span className="footer-logo-text">VantaSignal</span>
            </a>
            <p className="footer-company">VantaSignal Technologies LLC</p>
          </div>
          
          <nav className="footer-nav" data-testid="footer-nav">
            {footerLinks.map((link) => (
              <a 
                key={link.label} 
                href={link.href} 
                className="footer-link"
                data-testid={`footer-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} VantaSignal Technologies LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
